import type { Degree, Radian } from "../types/units/Units"

/**
 * Converts degrees to radians
 * @param degrees - The angle in degrees
 * @returns The angle in radians
 */
export const ToRadians = (degrees: Degree): Radian =>
  (degrees * (Math.PI / 180)) as Radian
